import { SongUb } from "../../gql/graphql";
import { ItemCard } from "./ItemCard";
import { DisplayImages } from "./DisplayImages";
import { CyItem } from "./CyItem";
import Auth from "../../auth/Auth";
import { useTranslation } from "react-i18next";

interface Props {
  auth: Auth;
  song: SongUb;
  reexecuteQuery: () => void;
  isDisabled?: boolean;
}

export function DerivedImagesCard({
  auth,
  song,
  reexecuteQuery,
  isDisabled = false,
}: Props) {
  const { t } = useTranslation();
  return (
    <ItemCard
      title={t("items.sourceFiles.derivedImagesTitle")}
      dataCy={CyItem.DerivedImagesCard}
      helpCollapsedArea={
        <>
          <ul>
            <li>{t("items.derivedImages.generatedFromSource")}</li>
            <li>{t("items.derivedImages.optimizedForTablet")}</li>
            <li>{t("items.derivedImages.orderCanBeChanged")}</li>
            <li>{t("items.derivedImages.canBeDeletedAndRegenerated")}</li>
          </ul>
        </>
      }
    >
      <DisplayImages
        auth={auth}
        bucket={song.bucket}
        songId={song.id}
        derivedImages={song.imageHashes}
        reexecuteQuery={reexecuteQuery}
        isDisabled={isDisabled}
      />
    </ItemCard>
  );
}
